import { render, staticRenderFns } from "./cpt-advantages.vue?vue&type=template&id=66b692f3&scoped=true"
import script from "./cpt-advantages.vue?vue&type=script&lang=js"
export * from "./cpt-advantages.vue?vue&type=script&lang=js"
import style0 from "./cpt-advantages.vue?vue&type=style&index=0&id=66b692f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b692f3",
  null
  
)

export default component.exports